import React from 'react';
import cloudIcon from '../../assets/cloud.png';
import FeatureDetail from './FeatureDetail';

const CloudSolutions = () => {
  const benefits = [
    {
      title: 'Access Anywhere',
      description: 'Access your business applications from anywhere in the world with just an internet connection.',
    },
    {
      title: 'Automatic Updates',
      description: 'Always have the latest features and security updates without manual intervention.',
    },
    {
      title: 'Reduced IT Costs',
      description: 'Minimize infrastructure costs and reduce the need for extensive on-site IT resources.',
    },
    {
      title: 'Scalability',
      description: 'Easily scale resources up or down based on your business needs without hardware limitations.',
    },
    {
      title: 'Enhanced Security',
      description: 'Benefit from enterprise-grade security measures, data encryption, and regular backups.',
    },
    {
      title: 'Disaster Recovery',
      description: 'Quick recovery from disasters with automated backups and redundant systems.',
    },
  ];

  const useCases = [
    {
      title: 'Remote Workforce',
      description: 'Enable your team to work remotely with full access to all necessary systems and data.',
    },
    {
      title: 'Multi-branch Operations',
      description: 'Connect multiple locations with a centralized system accessible to all branches.',
    },
    {
      title: 'Global Collaboration',
      description: 'Facilitate collaboration among teams across different geographical locations.',
    },
  ];

  const technologies = [
    { name: 'AWS', icon: '☁️' },
    { name: 'Azure', icon: '☁️' },
    { name: 'Google Cloud', icon: '☁️' },
    { name: 'Docker', icon: '🐳' },
    { name: 'Kubernetes', icon: '⚙️' },
  ];

  const screenshots = [
    { 
      image: 'https://images.unsplash.com/photo-1603695564702-7ce576f7501f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      caption: 'Cloud dashboard showing resource usage and performance metrics'
    },
    { 
      image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      caption: 'Mobile access to your business applications from anywhere'
    },
  ];

  return (
    <FeatureDetail
      title="Cloud Solutions"
      subtitle="Access your business applications anywhere, anytime with our secure cloud infrastructure."
      description={
        <div>
          <p>
            Our cloud solutions provide secure, scalable, and reliable infrastructure for your business applications.
            Whether you're looking to migrate existing systems to the cloud or build new cloud-native applications,
            our platform offers the flexibility and performance you need.
          </p>
          <p>
            With our cloud-based VCRP solution, you can access your data and applications from anywhere,
            on any device, while maintaining enterprise-grade security and compliance.
          </p>
        </div>
      }
      icon={cloudIcon}
      benefits={benefits}
      useCases={useCases}
      technologies={technologies}
      mainImage="https://images.unsplash.com/photo-1544197150-b99a580bb7a8?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
      screenshots={screenshots}
    />
  );
};

export default CloudSolutions;
